export default "/images/vendor/flag-icon-css/flags/1x1/ps.svg?8e2aad287a0b3284d3b1185306dda9b9";